module.exports = __webpack_public_path__ + "static/img/reference pics_house2.2fa41aa1.jpg";